<footer class="footer">
  <br/>

  <div class="section-sitemap">
    <div class="container">
      <div class="row">

        <!-- Company -->
        <div class="col-4 col-sm-4 col-md-4 col-lg-3 col-xl-3">
          <p class="footer-title">COMPANY</p>
          <ul class="list-unstyled footer-links">
            <li><a routerLink="/about">Our Story</a></li>
            <li><a routerLink="/membership">Pricing</a></li>
            <li><a routerLink="/team-plans">Team Plans</a></li>
            <li><a routerLink="/partners">For Workspaces</a></li>
            <li><a routerLink="/faq">FAQ</a></li>
          </ul>
        </div>

        <!-- Cities -->
        <div class="col-8 col-sm-6 col-md-8 col-lg-5 col-xl-6">
          <p class="footer-title">CITIES</p>
          <div class="row">
            <div class="col-6 col-lg-5 col-xl-4">
              <ul class="list-unstyled footer-links">
                <li><a routerLink="/discover/new-york">New York</a></li>
                <li><a routerLink="/discover/san-francisco">San Francisco</a></li>
                <li><a routerLink="/discover/los-angeles">Los Angeles</a></li>
                <li><a routerLink="/discover/chicago">Chicago</a></li>
                <li><a routerLink="/discover/washington-dc">Washington, D.C.</a></li>
                <li><a routerLink="/discover/boston">Boston</a></li>
              </ul>
            </div>
            <div class="col-6 col-lg-5 col-xl-4">
              <ul class="list-unstyled footer-links">
                <li><a routerLink="/discover/london">London</a></li>
                <li><a routerLink="/discover/barcelona">Barcelona</a></li>
                <li><a routerLink="/discover/amsterdam">Amsterdam</a></li>
                <li><a routerLink="/discover/lisbon">Lisbon</a></li>
                <li><a routerLink="/discover/berlin">Berlin</a></li>
                <li><a routerLink="/discover">See more &rarr;</a></li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Mobile -->
        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-3">
          <p class="footer-title">GET IT ON MOBILE</p>

          <span>
            <a href="https://itunes.apple.com/us/app/croissant-get-work-done-anywhere/id996707738?mt=8" target="_blank">
              <img src="/images/footer/ios.svg" width="100" alt="Get it for iOS" class="me-3 mb-3"/>
            </a>
          </span>

          <span class="me-3 mb-3 mt-3">
            <a href="https://play.google.com/store/apps/details?id=com.croissant.ios" target="_blank">
              <img src="/images/footer/android.svg" width="100" alt="Get it for Android" class="me-3 mb-3"/>
            </a>
          </span>

          <br/>
          <br/>

          <div>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLScM8cPDA6stzq9ksNIjqlFBppk-XlJef8OZw-WOOz6tNAOt6A/viewform" target="_blank">
              <small>Where should we go next? Let us know!</small>
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>

  <hr>

  <!-- Legal -->
  <div class="section-legal">
    <div class="container" itemscope itemtype="http://schema.org/LocalBusiness">

      <div class="row">
        <div class="col-12 col-md-6">
          <span class="me-3"><a routerLink="/privacy">Privacy</a></span>
          <span class="me-3"><a routerLink="/terms">Terms</a></span>
          <span class="me-3"><a href="https://blog.getcroissant.com" target="_blank">Blog</a></span>
          <span class="me-3"><a routerLink="/contact">Contact</a></span>
          <span class="me-3"><a routerLink="/sitemap">Site Map</a></span>
          <span class="me-3"><a href="https://twitter.com/GetCroissant" target="_blank" style="color: white;"><i class="bi bi-twitter-x"></i></a></span>
          <span class="me-3"><a href="https://www.facebook.com/getcroissant" target="_blank" style="color: white;"><i class="bi bi-facebook"></i></a></span>
          <span class="me-3"><a href="https://www.instagram.com/getcroissant" target="_blank" style="color: white;"><i class="bi bi-instagram"></i></a></span>
        </div>

        <div class="col-12 col-md-6">
          <div class="text-start text-md-end">
            <span>© {{ year }} <span itemprop="name">Croissant</span>, Inc.</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</footer>
